<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">下載轄下資料</h3>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-8">
                    <select v-model="ceadcd" class="form-control">
                        <!-- <option  v-if="checkRoleId" value="2">區部</option> -->
                        <option  v-if="roleId == 'SALES_MANAGER_01' || roleId == 'SALES_01'" value="0">區部轄下通訊處</option>
                        <option  v-if="roleId == 'SALES_MANAGER_01' || roleId == 'SALES_01'" value="2">專招轄下推展處</option>
                        <option  v-if="roleId == 'SALES_MANAGER_01' || roleId == 'SALES_01' " value="3">展業轄下展業課</option>
                        <option  v-if="roleId == 'SALES_MANAGER_01' || roleId == 'SALES_01' || ( roleId == 'SALES_MANAGER_02' && userCategoryId == 'A043')" value="4">展業轄下展業區</option>
                    </select>
                </div>
                <div class="col-4 text-left">
                    <a class="btn btn-default" style="margin:0px;" @click="confirm(ceadcd)">下載轄下資料</a>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CeadcdChooseModal2',
  data () {
    return {
        ceadcd:''
    }
  },
  props: {
    open: {
        type: Boolean,
        default: false
    },
    roleId: {
        type: String,
        default: ''
    },
    userCategoryId: {
        type: String,
        default: ''
    }
  },
  methods: {
    confirm(ceadcd){
      if(ceadcd == ''){
        this.$toast.info({title: '未選取轄下資料類別'})
        return
      }
      this.$emit('choose', ceadcd)
    }
  }
}
</script>
